import { ContentTableItem } from "src/components/ContentTable/ContentTable";

function safeTime(iso: string | null): number {
	if (!iso) return -Infinity;
	const time = new Date(iso).getTime();
	return Number.isFinite(time) ? time : -Infinity;
}

export function mapAnnouncementsToContentTableItems(
	announcements: MeeAnnouncement[]
): ContentTableItem[] {
	const sent = announcements.filter((a) => a.status === "sent");
	const scheduled = announcements.filter((a) => a.status === "scheduled");
	const draft = announcements.filter((a) => a.status === "draft");
	const expired = announcements.filter((a) => a.status === "expired");

	const sortedSent = [...sent].sort(
		(a, b) => safeTime(b.sentAt) - safeTime(a.sentAt)
	);
	const sortedScheduled = [...scheduled].sort(
		(a, b) => safeTime(a.scheduledAt) - safeTime(b.scheduledAt)
	);
	const sortedDraft = [...draft].sort((a, b) => a.title.localeCompare(b.title));
	const sortedExpired = [...expired].sort(
		(a, b) => safeTime(b.expiresAt) - safeTime(a.expiresAt)
	);

	const toItem = (
		announcement: MeeAnnouncement,
		isActive: boolean
	): ContentTableItem => ({
		id: announcement.id,
		name: announcement.title,
		createdBy: announcement.createdBy
			? `${announcement.createdBy.firstName} ${announcement.createdBy.lastName}`
			: undefined,
		lastUpdated: announcement.updatedAt ?? announcement.createdAt,
		isActive,
		data: {
			status: announcement.status,
			audienceType: announcement.audienceType,
			audiencePlatform: announcement.audiencePlatform,
			audienceUserIds: announcement.audienceUserIds,
			sentAt: announcement.sentAt,
			scheduledAt: announcement.scheduledAt,
			expiresAt: announcement.expiresAt
		}
	});

	return [
		...sortedSent.map((a) => toItem(a, true)),
		...sortedScheduled.map((a) => toItem(a, true)),
		...sortedDraft.map((a) => toItem(a, false)),
		...sortedExpired.map((a) => toItem(a, false))
	];
}
